import { Icon, InlineChildren, Text, ThemingContext } from '@doordash/design-language';
import { SizeSemantics, Sizes } from './constants';
import { ErrorIconWrapper } from './styles/ErrorMessage';
import PropTypes from 'prop-types';
import React from 'react';
import { getThemeFieldTextStyles } from '../utils';

var ErrorMessage = function ErrorMessage(_ref) {
  var id = _ref.id,
      error = _ref.error,
      size = _ref.size;
  var theme = React.useContext(ThemingContext);
  var themeFieldErrorLineHeights = getThemeFieldTextStyles({
    theme: theme,
    size: size,
    styleType: 'Error'
  });
  return /*#__PURE__*/React.createElement(InlineChildren, {
    size: InlineChildren.Sizes.XxSmall,
    alignItems: InlineChildren.Alignment.FlexStart,
    justifyContent: InlineChildren.Justification.FlexStart,
    id: id
  }, /*#__PURE__*/React.createElement(ErrorIconWrapper // LineHeight props from theme are used to ensure that
  // the error Icon is center aligned with the first line
  // of error message text
  , {
    containerHeight: themeFieldErrorLineHeights.mobile.lineHeight,
    desktopContainerHeight: themeFieldErrorLineHeights.desktop.lineHeight
  }, /*#__PURE__*/React.createElement(Icon, {
    shouldAdjustSmallSizesWhitespace: true,
    type: Icon.Types.WarningCircleFill,
    size: Icon.Sizes.Small,
    color: Icon.Colors.TextError,
    title: "Error"
  })), /*#__PURE__*/React.createElement(Text, {
    styles: Text.Styles["".concat(SizeSemantics[size], "Error")],
    color: Text.Colors.TextError
  }, error));
};

ErrorMessage.Sizes = Sizes;
ErrorMessage.propTypes = {
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  id: PropTypes.string,
  size: PropTypes.oneOf(Object.values(ErrorMessage.Sizes))
};
ErrorMessage.defaultProps = {
  size: ErrorMessage.Sizes.Medium
};
export default ErrorMessage;